import { useMemo } from 'react';
import { useGlobalStore } from '../../stores/use-global-store';
import './back-button.scss';
import emitter, { EVENT_NAME_BACK_HOME } from '../../utils/mitt';
import { reportEvent } from '../../utils/thinking/thinking';
import clsx from 'clsx';
export default function BackButton() {
  const { camState } = useGlobalStore();
  const isGlobalView = useMemo(() => {
    return camState === 0;
  }, [camState]);
  const onBack = () => {
    if (isGlobalView) {
      reportEvent('return_button', {
        button_type: '主页面',
      });
      setTimeout(() => {
        window.location.href = 'https://xjsj.cmge.com/home/';
        // window.open("https://xjsj.cmge.com/", "_blank");
      }, 100);
    } else {
      emitter.emit(EVENT_NAME_BACK_HOME);
    }
  };
  return (
    <div className="back_button_wrapper" onClick={onBack}>
      <div
        className={clsx(
          'fit_parent back_button back_button_local duration-500 transition-all',
          isGlobalView ? 'opacity-0' : 'opacity-100'
        )}
      ></div>
      <div
        className={clsx(
          'fit_parent back_button back_button_home duration-500 transition-all',
          !isGlobalView ? 'opacity-0' : 'opacity-100'
        )}
      ></div>
      <div className="fit_parent back_button_active"></div>
    </div>
  );
}
